// extracted by mini-css-extract-plugin
module.exports = {"category":"Samples-module--category--2s-Rk","container":"Samples-module--container--3rv8i"};